import { Stack, Button, Divider } from "@mui/material";

import {
  FieldInputText,
  FieldInputMask,
  FieldSelect,
} from "../../../../../components/Fields";

import Grid from "@mui/material/Grid";

import "../../styles.css";
import { useRef, useState } from "react";
import { filterNumberString } from "../../../../../utils/validarData";

export default function PainelDadosGerais({
  handleChangePanel,
  onSubmit,
  data,
  setData,
  pesoHabitual,
  simOuNaoOptions,
  statusCognitivoOptions,
}) {
  const [pesoAtualOnFocus, setPesoAtualOnFocus] = useState(false);
  const inputRef = useRef(null);
  const handleClick = () => {
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.setSelectionRange(7, 7);
      }, 80);
    }
  };

  function handlePesoAtual(e) {
    if (e.key >= "0" && e.key <= "9") {
      setData((prevState) => ({
        ...prevState,
        pesoAtual: (prevState.pesoAtual + e.key).slice(-6).padStart(6, "0"),
        perdaDePeso: handlePerdaDePeso(
          (prevState.pesoAtual + e.key).slice(-6).padStart(6, "0")
        ),
      }));
    } else if (e.key === "Backspace") {
      if (data.pesoAtual !== "000000") {
        setData((prevState) => ({
          ...prevState,
          pesoAtual: ("0" + prevState.pesoAtual.slice(0, -1)).padStart(6, "0"),
          perdaDePeso: handlePerdaDePeso(
            ("0" + prevState.pesoAtual.slice(0, -1)).padStart(6, "0")
          ),
        }));
      }
    } else if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
      e.preventDefault();
    }
  }

  function handlePerdaDePeso(value) {
    const newPeso = parseFloat(`${value.slice(0, 3)}.${value.slice(3)}`);
    if (newPeso < pesoHabitual) {
      return (((pesoHabitual - newPeso) / pesoHabitual) * 100).toFixed(3);
    } else {
      return "";
    }
  }

  function handleSetData(value, field) {
    setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }
  return (
    <form autoComplete="off" onSubmit={onSubmit}>
      <Stack className="templateGridForm" alignItems="end">
        <Grid item>
          <FieldInputText
            label="Frequência cardíaca"
            value={data.frequenciaCardiaca}
            setValue={(value) => {
              const numStr = filterNumberString(value, {
                valueMax: 300,
                length: 3,
              });
              handleSetData(numStr, "frequenciaCardiaca");
            }}
            type="text"
            helperText="Valor entre 0 a 300"
            unit="bpm"
          />
        </Grid>

        <Grid item>
          <FieldInputMask
            mask="999/99"
            label="Pressão arterial"
            value={data.pressaoArterial}
            setValue={(value) => handleSetData(value, "pressaoArterial")}
            placeholder="Ex: 190/80"
            helperText=" "
            unit="mmHg"
          />
        </Grid>

        <Grid item>
          <FieldInputMask
            label="Peso atual"
            mask="999,999"
            placeholder="Ex: 085,900"
            value={
              data.pesoAtual === "000000" && !pesoAtualOnFocus
                ? ""
                : data.pesoAtual
            }
            inputProps={{
              ref: inputRef,
            }}
            onClick={handleClick}
            onKeyDown={handlePesoAtual}
            onChange={(event) => {
              event.preventDefault();
            }}
            onFocus={() => setPesoAtualOnFocus(true)}
            onBlur={() => setPesoAtualOnFocus(false)}
            readOnly
            error={
              data.pesoAtual !== "000000" &&
              (parseInt(data.pesoAtual?.slice(0, 3)) < 30 ||
                parseInt(data.pesoAtual?.slice(0, 3)) > 250)
            }
            helperText={"O peso deve estar entre 30kg e 250kg."}
            unit="kg"
          />
        </Grid>

        <Grid item>
          <FieldInputText
            label="Perda de peso"
            value={data.perdaDePeso}
            setValue={(value) => handleSetData(value, "perdaDePeso")}
            disabled
            helperText=" "
            unit="%"
          />
        </Grid>

        <Grid item>
          <FieldInputText
            label="Fluência verbal"
            value={data.fluenciaVerbal}
            setValue={(value) => {
              const numStr = filterNumberString(value, {
                valueMax: 50,
                length: 2,
              });
              handleSetData(numStr, "fluenciaVerbal");
            }}
            helperText="Valor entre 0 a 50"
          />
        </Grid>

        <Grid item>
          <FieldInputText
            label="Rastreio comportamental (ECAS)"
            value={data.rastreioComportamental}
            setValue={(value) => {
              const numStr = filterNumberString(value, {
                valueMax: 10,
                length: 2,
              });
              handleSetData(numStr, "rastreioComportamental");
            }}
            helperText="Valor entre 0 a 10"
          />
        </Grid>

        <Grid item>
          <FieldSelect
            label="Apatia"
            value={data.apatia}
            setValue={(value) => handleSetData(value, "apatia")}
            items={simOuNaoOptions.map((c) => {
              return { id: c.value, label: c.key };
            })}
            helperText=" "
          />
          <br />
        </Grid>

        <Grid item>
          <FieldSelect
            label="Status cognitivo"
            value={data.statusCognitivo}
            setValue={(value) => handleSetData(value, "statusCognitivo")}
            items={statusCognitivoOptions.map((c) => {
              return { id: c.value, label: c.key };
            })}
          />
          <br />
        </Grid>
      </Stack>
      <Divider sx={{ mt: 4, mb: 4 }} />
      <Stack component="h2" className="titleSection">
        Função Pulmonar
      </Stack>
      <Stack className="templateGridForm" alignItems="end">
        <Grid item>
          <FieldInputText
            label="Capacidade Vital Forçada (CVF)"
            value={data.capacidadeVitalForcada}
            setValue={(value) => {
              const numStr = filterNumberString(value, {
                valueMax: 120,
                length: 2,
              });

              handleSetData(numStr, "capacidadeVitalForcada");
            }}
            helperText="Valor entre 0 a 120"
            unit="%"
          />
        </Grid>
        <Grid item>
          <FieldInputText
            label="Pressão Inspiratória (PI)"
            value={data.pressaoInspiratoria}
            setValue={(value) => {
              const numStr = filterNumberString(value, {
                valueMax: 110,
                length: 3,
              });
              handleSetData(
                numStr > 0 ? `-${numStr}` : numStr,
                "pressaoInspiratoria"
              );
            }}
            helperText="Valor entre -110 a 0"
            unit="cmH2O"
          />
        </Grid>

        <Grid item>
          <FieldInputText
            label="Pressão Expiratória (PE)"
            value={data.pressaoExpiratoria}
            setValue={(value) => {
              const numStr = filterNumberString(value, {
                valueMax: 150,
                length: 3,
              });
              handleSetData(numStr, "pressaoExpiratoria");
            }}
            helperText="Valor entre 0 a 150"
            unit="cmH2O"
          />
        </Grid>
        <Grid item>
          <FieldInputText
            label="Pressão Nasal Inspiratória (SNIP)"
            value={data.pressaoNasalInspiratoria}
            setValue={(value) => {
              const numStr = filterNumberString(value, {
                valueMax: 200,
                length: 3,
              });
              handleSetData(numStr, "pressaoNasalInspiratoria");
            }}
            helperText="Valor entre 0 a 200"
            unit="cmH2O"
          />
        </Grid>
      </Stack>

      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 3,
        }}
      >
        <Button variant="outlined" className="buttonText cancel">
          Cancelar
        </Button>
        <Button
          variant="contained"
          type="submit"
          name="dadosGerais"
          className="buttonText submit"
        >
          Salvar
        </Button>
      </Stack>
    </form>
  );
}
